import logger from '../../../library/Core/logger';
import { axiosClient } from '../../../library/Service/axiosClient';

class SchoolStatisticsService {
    static pageLoader(params: any) {
        const state: any = {};
        const { instituteId, pageName } = params;
    
            return Promise.all([
                this.getSchoolCount(instituteId),
                this.getSchoolFieldList(instituteId),
                this.getSchoolQuarterFilter(instituteId),
            ])
            .then((values) => {
                state.formConfig = {};
                state.data = {
                    schoolCount : values[0].data,
                    fieldList  :  values[1]?.data,
                    quarters: [
                        { label: 'All Time', cODE: 'ALL' },
                        ...values[2].data,
                    ]
                };
                state.routeInfo = { instituteId, pageName };
                return Promise.resolve(state);
            })
            .catch(function (err) {
                logger.log(`Error in loading data for ${pageName} and the error is:`);
                console.log(err);
            });
    }

    static getSchoolCount = async (instituteId:any,quarterTime: string = 'ALL') => {
        return axiosClient().post(`${process.env.REACT_APP_INTERNAL_ADMIN_SERVER}/institute-tracker/school-count`,
            {"schoolIdStatistics" : instituteId,"quarterTime" : quarterTime});
    };

    static getSchoolFieldList = async (instituteId: string, quarterTime: string = 'ALL') => {
        return axiosClient().post(`${process.env.REACT_APP_INTERNAL_ADMIN_SERVER}/institute-tracker/school-field-list`,{instituteId,quarterTime});
    };

    static getSchoolQuarterFilter = async (instituteId:any) => {
        return axiosClient().get(`${process.env.REACT_APP_INTERNAL_ADMIN_SERVER}/institute-tracker/school-quarter-filter/${instituteId}`);
    };

    static exportToPPT = async (instituteId: string) => {
        return axiosClient().post(`${process.env.REACT_APP_INTERNAL_ADMIN_SERVER}/institute-tracker/download-tracker-slide`,{instituteId});
    };

}

export default SchoolStatisticsService;
